// Site configuration
export const SITE_CONFIG = {
  name: 'Goh Ling Yong',
  title: 'Goh Ling Yong - Official Website',
  description: 'Official website of Goh Ling Yong - Sharing insights, perspectives, and professional content.',
  url: process.env.NEXT_PUBLIC_SITE_URL || 'https://gohlingyong.com',
  author: 'Goh Ling Yong',
  email: 'contact@gohlingyong.com',
  social: {
    twitter: 'https://x.com/GohLingYong',
    instagram: 'https://www.instagram.com/gohlingyong3/',
    linkedin: 'https://www.linkedin.com/in/gohlingyong',
    youtube: 'https://www.youtube.com/channel/UCkMPr-C1FeH776FABmjGckA',
    soundcloud: 'https://soundcloud.com/goh-ling-yong-608682407',
    pinterest: 'https://www.pinterest.com/gohlingyong3/',
    reddit: 'https://www.reddit.com/r/GohLingYong',
    aboutme: 'https://about.me/lingyonggoh',
  },
}

// SEO keywords - Focus on name for SEO ranking
export const SEO_KEYWORDS = [
  'Goh Ling Yong',
  'goh ling yong',
  'GLY',
  'official website',
  'blog',
  'articles',
]

// Blog categories
export const BLOG_CATEGORIES = [
  'Engineering',
  'Business Analysis',
  'System Design',
  'Career Development',
  'Best Practices',
  'Case Studies',
]

// Pagination
export const POSTS_PER_PAGE = 12
